import { render, staticRenderFns } from "./TemplateOrderEdit.vue?vue&type=template&id=6df9bdbe&scoped=true"
import script from "./TemplateOrderEdit.vue?vue&type=script&lang=js"
export * from "./TemplateOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df9bdbe",
  null
  
)

export default component.exports